import {
  addDays,
  differenceInHours,
  differenceInMinutes,
  isAfter,
  isBefore,
  isSameDay,
  set,
} from "date-fns";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { Calendar, DateObject } from "react-multi-date-picker";
import { useWindowDimensions } from "../../lib/windows";
import appStore from "../../store";
import { toast } from "react-toastify";
import toastErrorAndReport from "lib/toastErrorAndReport";
import { getNewStartDays } from "lib/common";

const TIME_OPTIONS = [
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];

const TimeSelectorContent = () => {
  const { t } = useTranslation("common");
  const { width } = useWindowDimensions();
  const router = useRouter();
  const { locale } = router;

  const {
    latestOrderTimeUnion,
    timeOptsUnion,
    selectedDays,
    selectedStartClock,
    selectedEndClock,
    tempSelectedDays,
    tempSelectedEndClock,
    tempSelectedStartClock,
  } = appStore;
  const minDate = new DateObject().add(latestOrderTimeUnion, "minutes");
  const [values, setValues] = useState(selectedDays);

  useEffect(() => {
    if (values.length === 2) {
      appStore.tempSelectedDays = values;
    }
  }, [values]);

  useEffect(() => {
    if (selectedDays.length === 2) {
      setValues(selectedDays);
    }
  }, [selectedDays]);

  useEffect(() => {
    if (tempSelectedDays.length === 2) {
      // 如果開始日期在2024/02/06-2024/02/16之間，將日期設定回預設日期
      const isBetween =
        isBefore(
          new Date(tempSelectedDays[1].format()),
          new Date("2025/02/03")
        ) &&
        isAfter(new Date(tempSelectedDays[1].format()), new Date("2025/01/23"));
      if (isBetween) {
        const newStartDays = getNewStartDays();
        appStore.tempSelectedDays = newStartDays;
        appStore.selectedDays = newStartDays;
      }
    }
  }, [tempSelectedDays]);

  useEffect(() => {
    if (tempSelectedDays.length === 2) {
      if (tempSelectedStartClock !== "" && tempSelectedEndClock !== "") {
        let diff = differenceInMinutes(
          new Date(
            tempSelectedDays[1].format("YYYY/MM/DD") +
              " " +
              tempSelectedEndClock
          ),
          new Date(
            tempSelectedDays[0].format("YYYY/MM/DD") +
              " " +
              tempSelectedStartClock
          )
        );
        if (diff < 1440) {
          appStore.tempSelectedEndClock = "";
          return alert(t("timeError"));
        }
      }
    } else {
      setValues([]);
    }
  }, [t, tempSelectedDays, tempSelectedEndClock, tempSelectedStartClock]);

  const mapDays = useMemo(() => {
    const disableDate = ({ date }) => {
      // 處理過年期間，時間在 2026/02/14 到 2026/02/22 之間的話，全部disable
      const isBetween =
        isBefore(new Date(date.format()), new Date("2026/02/23")) &&
        isAfter(new Date(date.format()), new Date("2026/02/13"));
      if (isBetween) {
        return {
          disabled: true,
          style: { color: "#ccc" },
        };
      }
    };
    return disableDate;
  }, []);

  return (
    <Calendar
      range
      mapDays={mapDays}
      value={values}
      onChange={(e) => {
        if (e.length === 2) {
          if (
            isBefore(new Date(e[0].format()), new Date("2025/01/24")) &&
            isAfter(new Date(e[1].format()), new Date("2025/01/23"))
          ) {
            toastErrorAndReport(t("Calendar_over_newyear"));
            const startDate = new DateObject(e[0]);
            if (isSameDay(new Date(e[0].format()), new Date("2025/01/23"))) {
              setValues([startDate.subtract(1, "days"), e[0]]);
              return;
            } else {
              setValues([e[0], startDate.add(1, "days")]);
              return;
            }
          } else {
            setValues(e);
          }
        } else {
          setValues(e);
        }
      }}
      numberOfMonths={width >= 768 ? 2 : 1}
      minDate={minDate}
      currentDate={new DateObject().add(1, "days")}
      maxDate={new DateObject().add(3, "months")}
    />
  );
};
export default TimeSelectorContent;
